import { Box, Button, Typography } from "@mui/material";

export const SpdmImport: React.FC = () => (
    <Box p={2}>
        <Typography>SPDMからデータを読み込みます。</Typography>
        <Button
            variant="contained"
            component="label"
            sx={{ mt: 2 }}
            disabled={true}
        >
            全データコピー
        </Button>
    </Box>
);